/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const MessageIcon = /*#__PURE__*/ createSvgIcon(
  'MessageIcon',
  {
    ltr: {
      small: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.13 1.13A7.5 7.5 0 118 15.56h-.013a8.5 8.5 0 01-3.8-1.012L1.408 15.56H1.11a.6.6 0 01-.368-.122.6.6 0 01-.201-.283.92.92 0 01-.041-.298v-.094l1.032-2.887A8.5 8.5 0 01.5 8.076V8.06a7.5 7.5 0 014.63-6.93zm-3.05 10.7l.47.168-.855 2.393 2.582-.94.202.115a7.5 7.5 0 003.528.994A6.5 6.5 0 101.5 8.052a7.5 7.5 0 001.012 3.527l-.432.251z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h16v16H0z" />
            </clipPath>
          </defs>
        </>
      ),
      medium: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.365 1.223A9.5 9.5 0 1110 19.5h-.015a10.82 10.82 0 01-4.879-1.33L1.51 19.5h-.37a.626.626 0 01-.388-.13.628.628 0 01-.209-.3 1.08 1.08 0 01-.043-.338V18.634l1.332-3.737A10.82 10.82 0 01.5 10.015V10a9.5 9.5 0 015.865-8.777zM2.38 14.85l.471.168-1.2 3.363 3.546-1.311.203.117a9.82 9.82 0 004.608 1.313A8.5 8.5 0 101.5 9.992 9.82 9.82 0 002.813 14.6l-.433.25z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.6 1.375A11.5 11.5 0 1112 23.5h-.016a13.1 13.1 0 01-5.948-1.64L1.599 23.5H1.17a.653.653 0 01-.405-.134.656.656 0 01-.218-.314c-.049-.146-.048-.308-.047-.377v-.102l1.642-4.605A13.1 13.1 0 01.5 12.016V12A11.5 11.5 0 017.6 1.375zm6.448.327A10.5 10.5 0 001.5 11.992a12.1 12.1 0 001.623 5.677l.116.2-1.626 4.56 4.514-1.67.204.118a12.1 12.1 0 005.677 1.623 10.5 10.5 0 002.04-20.798z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default MessageIcon;
